export default __webpack_public_path__ + "static/media/Spotify_Logo_RGB_Green.0c4ae91b.png";